import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ActionsList from './List';

export default function ActionsRouter() {
  return (
    <Routes>
      <Route path="" element={<ActionsList />} />
      <Route path=":id" element={<ActionDetailsRouter />} />
    </Routes>
  );
}

function ActionDetailsRouter() {
  const { useParams } = require('react-router-dom');
  const params = useParams();
  const ActionDetailsPage = require('./Details').default;
  return <ActionDetailsPage id={params.id} />;
}

// ActionsList moved to ./List.js
// Note: details component moved into ./Details.js and is rendered via nested route

